import mori from 'mori';
import { appDefault } from '../../config/config';
import { filterByRow } from './';

/**
 * [buildRowData description]
 * @TODO finish documenting this out
 * @param  {[type]} timeframes    [description]
 * @param  {[type]} keys          [description]
 * @param  {[type]} combined      [description]
 * @param  {[type]} footnotes     [description]
 * @param  {[type]} trend         [description]
 * @param  {[type]} distributions [description]
 * @return {[type]}               [description]
 */
export default function(
  timeframes,
  keys,
  combined,
  trend
) {
  // Build a map of footnotes ids by order of assignment in the table
  const shouldFilter = !mori.isEmpty(combined);
  const withSummary = mori.some((base) => mori.reduce(
    (acc, sel) => acc ?
      acc :
      appDefault.isSummaryRow.test(mori.last(mori.first(sel))),
    false,
    base
  ), combined) || false;

  const test = mori.map(
    (timeframe) => mori.transduce(
      mori.comp(
        mori.map((row) =>
          appDefault.isSummaryRow.test(
            mori.get(row, mori.first(mori.keys(row)))
          ) ?
          mori.assoc(
            mori.assoc(
              row,
              mori.first(mori.keys(row)),
              mori.get(row, mori.first(mori.keys(row)))
                .replace(appDefault.isSummaryRow, '')
            ),
            'isSummary',
            true
          ) :
          row
        ),
        mori.filter((row) =>
          filterByRow(row, combined, shouldFilter, withSummary)),
        mori.map((row) => {
          return mori.assoc(mori.into(
            mori.hashMap(
              mori.first(mori.first(keys)),
              mori.get(row, mori.first(keys))
            ),
            mori.map(
              (select) => {
                return mori.hashMap(
                  (trend ?
                    `${mori.first(timeframe)}__` :
                    ''
                  ) + (mori.count(select) === 3 ?
                  `${mori.first(select)}__${mori.first(mori.rest(select))}` :
                    mori.first(select)),
                  mori.get(row, select)
                );
              },
              mori.rest(keys)
            )
          ), 'isSummary', mori.get(row, 'isSummary'));
        })
      ),
      mori.completing(mori.conj),
      mori.vector(),
      mori.last(timeframe)
    ),
    timeframes
  );

  // Filter timeframe data by baseColumn selections
  const rowData = mori.map(
    (group) => {
      return mori.into(
        mori.hashMap(),
        mori.toClj(group)
      );
    },
    mori.map(
      mori.vector,
      ...mori.toJs(test)
    )
  );

  return mori.toJs(mori.hashMap(
    'rowData', rowData,
  ));
}



// WEBPACK FOOTER //
// ../datacenter/app/js/services/table/buildRowData.js